<div *ngIf="!(sisifoUserHasRelatedCenter$ | async)">
  {{ "WEB_RESULTS.ERROR.NO_PERMISSION" | translate }}
</div>

<form
  [formGroup]="form"
  class="form-basic"
  (submit)="search()"
  *ngIf="sisifoUserHasRelatedCenter$ | async"
>
  <div class="form-field">
    <label for="labRequestFrom">{{
      "PATIENT_REQUESTS.SEARCH.LAB_REQUEST_FROM" | translate
    }}</label>
    <input
      id="labRequestFrom"
      type="text"
      maxlength="14"
      pInputText
      formControlName="labRequestFrom"
      [class.disabled]="form.get('labRequestFrom')?.disabled"
    />
  </div>

  <div class="form-field">
    <label for="labRequestTo">{{
      "PATIENT_REQUESTS.SEARCH.LAB_REQUEST_TO" | translate
    }}</label>
    <input
      id="labRequestTo"
      type="text"
      pInputText
      maxlength="14"
      formControlName="labRequestTo"
      [class.disabled]="form.get('labRequestTo')?.disabled"
    />
  </div>

  <div class="form-field">
    <label for="centerRequestFrom">{{
      "PATIENT_REQUESTS.SEARCH.CENTER_REQUEST_FROM" | translate
    }}</label>
    <input
      id="centerRequestFrom"
      type="text"
      maxlength="20"
      pInputText
      formControlName="centerRequestFrom"
      [class.disabled]="form.get('centerRequestFrom')?.disabled"
    />
  </div>

  <div class="form-field">
    <label for="centerRequestTo">{{
      "PATIENT_REQUESTS.SEARCH.CENTER_REQUEST_TO" | translate
    }}</label>
    <input
      id="centerRequestTo"
      type="text"
      maxlength="20"
      pInputText
      formControlName="centerRequestTo"
      [class.disabled]="form.get('centerRequestTo')?.disabled"
    />
  </div>

  <div class="form-field">
    <label for="extractionFrom">{{
      "PATIENT_REQUESTS.SEARCH.EXTRACTION_DATE_FROM" | translate
    }}</label>
    <p-calendar
      dateFormat="dd/mm/yy"
      inputId="extractionFrom"
      formControlName="extractionFrom"
      [readonlyInput]="true"
      [firstDayOfWeek]="1"
      [class.disabled]="form.get('extractionFrom')?.disabled"
      [maxDate]="form.get('extractionTo')?.value ?? today"
      [showButtonBar]="true"
    ></p-calendar>
  </div>

  <div class="form-field">
    <label for="extractionTo">{{
      "PATIENT_REQUESTS.SEARCH.EXTRACTION_DATE_TO" | translate
    }}</label>
    <p-calendar
      dateFormat="dd/mm/yy"
      inputId="extractionTo"
      formControlName="extractionTo"
      [readonlyInput]="true"
      [firstDayOfWeek]="1"
      [class.disabled]="form.get('extractionTo')?.disabled"
      [minDate]="form.get('extractionFrom')?.value"
      [maxDate]="today"
      [showButtonBar]="true"
    ></p-calendar>
  </div>

  <div class="form-field" *ngIf="sisifoUserHasRelatedDoctor$ | async">
    <h4>{{ "PATIENT_REQUESTS.SEARCH.BY_USER" | translate }}</h4>
    <p-checkbox
      [binary]="true"
      formControlName="searchByUser"
      inputId="searchByUser"
    ></p-checkbox>
  </div>

  <div class="btns-container">
    <p-button
      [label]="'PATIENT_REQUESTS.SEARCH.CLEAR' | translate"
      (click)="clear()"
    ></p-button>
    <p-button
      [label]="'PATIENT_REQUESTS.SEARCH.SEARCH' | translate"
      type="submit"
    ></p-button>
  </div>
</form>
